import { reactive, ref } from 'vue';

const instance = ref<HTMLDialogElement | null>(null);

interface DialogPayload {
    title: string;
    description: string;
    type: 'success' | 'error';
    mode: 'alert' | 'confirm';
    okText?: string;
}

const payload = reactive<DialogPayload>({
    title: '',
    description: '',
    type: 'success' as 'success' | 'error',
    mode: 'alert' as 'alert' | 'confirm',
    okText: 'Ok',
});
let resolveFn: ((value: boolean) => void) | null = null;

export function useDialog() {
    function show(data: DialogPayload) {
        return new Promise<boolean>((resolve) => {
            payload.title = data.title;
            payload.description = data.description;
            payload.type = data.type;
            payload.mode = data.mode;
            payload.okText = data.okText || 'Ok';
            resolveFn = resolve;
            instance.value?.showModal();
        });
    }
    function alert(title: string, description: string, type: 'success' | 'error' = 'success', okText: string = 'Ok') {
        return show({ title, description, type, mode: 'alert', okText });
    }
    function confirm(title: string, description: string, type: 'success' | 'error' = 'success', okText: string = 'Ok') {
        return show({ title, description, type, mode: 'confirm', okText });
    }

    function register(dialog: HTMLDialogElement) {
        instance.value = dialog;
    }

    function handleClose() {
        if (resolveFn) {
            resolveFn(instance.value?.returnValue === 'confirm');
            resolveFn = null;
        }
    }

    return {
        alert,
        confirm,
        register,
        payload,
        handleClose,
    };
}
